import React, { useEffect, useState } from 'react';
import NavigationItem, { NavigationItemProps } from './NavigationItem';

export interface NavigationProps {
  defaultValue?: string;
  onSelectItem?: (item?: string) => void;
  items?: Pick<NavigationItemProps, 'label' | 'iconClassName'>[];
}

const Navigation = React.memo(
  ({ defaultValue, onSelectItem, items }: NavigationProps) => {
    const [selectedLabel, setSelectedLabel] = useState(defaultValue);

    useEffect(() => {
      onSelectItem?.(selectedLabel);
    }, [selectedLabel]);

    return (
      <div
        id='builder-sidebar-navigation'
        className='v2-bg-neutral-800 w-20 flex flex-col text-base'
      >
        {items?.map((item, key) => {
          return (
            <NavigationItem
              {...item}
              key={key}
              onSelected={setSelectedLabel}
              selected={item.label === selectedLabel}
            />
          );
        })}
      </div>
    );
  }
);

Navigation.displayName = 'Navigation';

export default Navigation;
